import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("授权");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消授权");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("设置备注");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("客服维护");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存");

import { ref } from 'vue';
import { getVexTableProps } from '@/config';
import { getDeviceAuthList, updateDeviceAuth, setNote, exportForAsync } from '@/request';
import { exportDeviceAuthList } from '@/request/api';
import { ElMessage } from 'element-plus';
import setCusServiceModal from './component/setCusServiceModal.vue';
export default {
  name: 'DeviceAuth',

  setup(__props) {
    const form = ref({
      linkMan: '',
      supplierName: '',
      loginName: '',
      limitStatus: ''
    });
    const formRef = ref();
    const table = ref();
    let dataTotal = 0;
    const showSetNoteModal = ref(false);
    const noteText = ref('');
    const showCusServiceModal = ref(false);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '状态',
        field: 'limitStatus',
        width: '100px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createTime',
        width: '200px',
        showOverflow: true
      }, {
        title: '授权时间',
        field: 'authorizeDate',
        width: '200px',
        showOverflow: true
      }, {
        title: '最后登录时间',
        field: 'lastLoginDate',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员',
        field: 'linkMan',
        width: '100px',
        showOverflow: true
      }, {
        title: '登录名称',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }, {
        title: '设备型号',
        field: 'model',
        width: '150px',
        showOverflow: true
      }, {
        title: '系统版本',
        field: 'systemVersion',
        width: '150px',
        showOverflow: true
      }, {
        title: 'IMEI',
        field: 'imei',
        width: '250px',
        showOverflow: true
      }, {
        title: '备注',
        field: 'note',
        width: '250px',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getDeviceAuthList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              dataTotal = data.total;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    function exportFile() {
      exportForAsync(_objectSpread(_objectSpread({}, form.value), {}, {
        modularflag: 'equipmentInfo',
        fileName: '设备授权',
        count: dataTotal,
        methodName: exportDeviceAuthList.url
      }));
    }

    function updateAuth(state = 1) {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作');
        return;
      }

      updateDeviceAuth({
        limitStatus: state,
        phoneLimitIds: selectRows.map(item => item.phoneLimitId).join(','),
        __warn: true,
        __repeat: true
      }).then(data => {
        if (data.success) {
          ElMessage.success('操作成功!');
          table.value.commitProxy('query');
        }
      }); // deviceAuth
    }

    function showSetNote() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作');
        return;
      }

      if (selectRows.length !== 1) {
        ElMessage.warning('只能勾选一条数据进行操作');
        return;
      }

      noteText.value = '';
      showSetNoteModal.value = true;
      noteText.value = '';
    }

    function saveNote() {
      let row = table.value.getCheckboxRecords()[0];

      if (row) {
        setNote({
          note: noteText.value,
          phoneLimitId: row.phoneLimitId,
          __warn: true,
          __repeat: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('设置备注成功!');
            showSetNoteModal.value = false;
            table.value.commitProxy('query');
          }
        });
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        "label-width": "80px",
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "linkMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属团队",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "账号",
              prop: "loginName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.loginName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.loginName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态",
              prop: "limitStatus"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.limitStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.limitStatus = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "待审核",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "正常",
                  value: "1"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: exportFile,
          icon: "Download"
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => updateAuth(1)),
          type: "primary"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => updateAuth(0)),
          type: "danger"
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: showSetNote,
          type: "success"
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => showCusServiceModal.value = true),
          type: "warning"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        title: "设置备注",
        modelValue: showSetNoteModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showSetNoteModal.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => showSetNoteModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: saveNote
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: noteText.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => noteText.value = $event),
            type: "textarea",
            autosize: {
              minRows: 4,
              maxRows: 6
            },
            "show-word-limit": "",
            maxlength: "100"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(setCusServiceModal, {
        modelValue: showCusServiceModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showCusServiceModal.value = $event)
      }, null, 8, ["modelValue"])]);
    };
  }

};